<template>
  <div>
    <disponibilidade-dialog
      :is-dialog-open.sync="isDisponibilidadeDialogOpen"
      :ticket-id="ticketId"
      @selecionar-data="handleSelecionarDataAgendamento"
    />

    <v-form
      ref="formRef"
      class="multi-col-validation"
      @submit.prevent="handleSubmitBtnClick"
    >
      <v-expand-transition>
        <v-row v-if="!isAgendamentoNovo">
          <v-col cols="12">
            <v-text-field
              v-model="agendamentoSelecionado.protocolo"
              dense
              outlined
              label="Protocolo"
              disabled
            />
          </v-col>
        </v-row>
      </v-expand-transition>

      <v-row>
        <v-col
          md="4"
          cols="12"
        >
          <v-tooltip
            top
            color="info"
          >
            <template #activator="{ attrs, on }">
              <div
                v-bind="attrs"
                v-on="on"
              >
                <date-picker
                  :date-iso.sync="dataAgendamento"
                  label="Data do agendamento"
                  required
                  disabled
                  :min-date-iso="dataMinimaAgendamento"
                />
              </div>
            </template>
            <span>Use o botão de disponibilidade para selecionar a data e horário do agendamento</span>
          </v-tooltip>
        </v-col>

        <v-col
          md="4"
          cols="12"
        >
          <v-tooltip
            top
            color="info"
          >
            <template #activator="{ attrs, on }">
              <div
                v-bind="attrs"
                v-on="on"
              >
                <time-picker
                  :time-iso.sync="horarioVisitaAgendamento"
                  label="Horário da visita"
                  required
                  disabled
                  :min-time-iso="horarioMinimoAgendamento"
                />
              </div>
            </template>
            <span>Use o botão de disponibilidade para selecionar a data e horário do agendamento</span>
          </v-tooltip>
        </v-col>

        <v-col
          md="4"
          cols="12"
        >
          <v-text-field
            :value="descricaoTipoAgendamento"
            label="Tipo de Agendamento"
            outlined
            dense
            readonly
            filled
            persistent-hint
          />
        </v-col>

        <v-col cols="12">
          <v-tooltip
            top
            color="info"
          >
            <template #activator="{ attrs, on }">
              <div
                v-bind="attrs"
                v-on="on"
              >
                <v-select
                  v-model="agendamento.agenteId"
                  dense
                  outlined
                  label="Responsável"
                  item-value="id"
                  item-text="nome"
                  disabled
                  :items="agentesExternos"
                  :loading="isGetAgentesExternosLoading"
                  @change="handleSelectAgenteExterno"
                />
              </div>
            </template>
            <span>Use o botão de disponibilidade para selecionar a data e horário do agendamento</span>
          </v-tooltip>
        </v-col>

        <v-expand-transition>
          <v-col
            v-if="agendamento.agenteId"
            md="6"
            cols="12"
          >
            <v-text-field
              v-model="agenteExternoSelecionado.telefone"
              dense
              outlined
              label="Telefone"
              disabled
            />
          </v-col>
        </v-expand-transition>

        <v-expand-transition>
          <v-col
            v-if="agendamento.agenteId"
            md="6"
            cols="12"
          >
            <v-text-field
              v-model="agenteExternoSelecionado.email"
              dense
              outlined
              label="Email"
              disabled
            />
          </v-col>
        </v-expand-transition>
      </v-row>

      <v-row class="align-center">
        <v-col cols="auto">
          <v-checkbox
            v-if="solicitantePrimeiroEnderecoCadastrado"
            v-model="usarEnderecoCadastro"
            hide-details
            label="Usar endereço do cadastro"
            class="mt-0"
            :disabled="desabilitarCampos"
            @change="handleUsarEnderecoCadastroCheckboxChange"
          />

          <v-tooltip
            v-else
            top
            color="error"
          >
            <template #activator="{ attrs, on }">
              <div
                v-bind="attrs"
                v-on="on"
              >
                <v-checkbox
                  v-model="usarEnderecoCadastro"
                  hide-details
                  label="Usar endereço do cadastro"
                  class="mt-0"
                  disabled
                  @change="handleUsarEnderecoCadastroCheckboxChange"
                />
              </div>
            </template>

            <span>O solicitante não possui endereços cadastrados, portanto não é possível marcar o checkbox</span>
          </v-tooltip>
        </v-col>

        <v-col cols="auto">
          <v-checkbox
            v-model="agendamento.notificarLembrete"
            hide-details
            label="Notificar lembrete?"
            class="mt-0"
            :disabled="desabilitarCampos"
          />
        </v-col>

        <v-col cols="auto">
          <v-text-field
            v-model="agendamento.diasDeLembrete"
            dense
            outlined
            label="Dias para lembrete"
            type="number"
            validate-on-blur
            min="1"
            class="mt-0"
            :disabled="desabilitarCampos"
            :rules="[v => !v || Number(v) >= 1 || 'O valor deve ser maior ou igual a 1']"
          />
        </v-col>
      </v-row>

      <endereco-form-fields
        class="my-4"
        :endereco-data="enderecoVisita"
        :disabled="usarEnderecoCadastro || desabilitarCampos"
        required
        @update:cep="v => enderecoVisita.cep = v"
        @update:rua="v => enderecoVisita.rua = v"
        @update:numero="v => enderecoVisita.numero = v"
        @update:complemento="v => enderecoVisita.complemento = v"
        @update:estado="v => enderecoVisita.estado = v"
        @update:bairro="v => enderecoVisita.bairro = v"
        @update:cidade="v => enderecoVisita.cidade = v"
        @update:ponto-de-referencia="v => enderecoVisita.pontoDeReferencia = v"
      />

      <v-expand-transition>
        <v-row v-if="!isAgendamentoNovo">
          <v-col cols="12">
            <v-select
              v-model="statusSelecionadoId"
              dense
              outlined
              label="Status"
              item-value="id"
              item-text="nome"
              :items="agendamentosStatus"
              :loading="isGetAgendamentosStatusLoading"
              :rules="[validators.select]"
            />
          </v-col>
        </v-row>
      </v-expand-transition>

      <v-expand-transition>
        <v-row v-if="isAgendamentoNovo">
          <v-col cols="12">
            <v-textarea
              v-model="agendamento.comentario"
              dense
              outlined
              label="Comentário"
              no-resize
              counter="500"
              :rules="[v => !v || v.length <= 500 || 'Máximo de 500 caracteres']"
            />
          </v-col>
        </v-row>
      </v-expand-transition>

      <v-row>
        <v-col
          cols="12"
          class="d-flex justify-center"
        >
          <v-btn
            v-if="isAgendamentoNovo"
            color="primary"
            outlined
            class="mr-4"
            :disabled="isSaveAgendamentoLoading"
            @click="isDisponibilidadeDialogOpen = !isDisponibilidadeDialogOpen"
          >
            <v-icon left>
              {{ icons.mdiCalendarCheck }}
            </v-icon>

            <span>Disponibilidade</span>
          </v-btn>

          <v-btn
            type="submit"
            color="primary"
          >
            <v-progress-circular
              v-if="isSaveAgendamentoLoading"
              class="mx-3"
              color="secondary"
              indeterminate
            />

            <span v-else>Salvar</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import Vue from 'vue'
import { onMounted, ref, computed, watch } from '@vue/composition-api'
import { mdiCalendarCheck } from '@mdi/js'
import { required, select } from '@/@core/utils/validation'
import DisponibilidadeDialog from './DisponibilidadeDialog.vue'
import DatePicker from '@/components/date-picker/DatePicker.vue'
import TimePicker from '@/components/time-picker/TimePicker.vue'
import EnderecoFormFields from '@/components/endereco/EnderecoFormFields.vue'
import TicketService from '@/services/modules/TicketService'
import EquipeService from '@/services/modules/EquipeService'
import TicketAgendamentoTipoService from '@/services/modules/TicketAgendamentoTipoService'
import EnderecoModel from '@/models/components/endereco/Endereco'
import useForm from '@/composables/useForm'
import {
  getDataAtualNoFormatoIsoDateString,
  getHorarioLocalAtualComApenasHorasEMinutos,
  concatenarIsoDateStringETimeStringEmIsoDateTimeString,
  getTimeStringComApenasHorasEMinutos,
} from '@/utils/dateTime'

export default {
  emits: ['refetch-data'],

  components: {
    DisponibilidadeDialog,
    DatePicker,
    TimePicker,
    EnderecoFormFields,
  },

  props: {
    ticketId: {
      type: Number,
      required: true,
    },
    solicitantePrimeiroEnderecoCadastrado: {
      type: Object,
      default: null,
    },
    agendamentoSelecionado: {
      type: Object,
      default: null,
    },
  },

  setup(props, { emit }) {
    const { formRef, loading: isSaveAgendamentoLoading, resetFormValidation, validateForm, FORM_ERROR } = useForm()

    const isDisponibilidadeDialogOpen = ref(false)
    const usarEnderecoCadastro = ref(false)

    const agentesExternos = ref([])
    const agendamentosStatus = ref([])
    const isGetAgentesExternosLoading = ref(false)
    const isGetAgendamentosStatusLoading = ref(false)

    const dataAgendamento = ref(null)
    const horarioVisitaAgendamento = ref(null)
    const dataMinimaAgendamento = ref(getDataAtualNoFormatoIsoDateString())
    const horarioMinimoAgendamento = computed(() => (dataAgendamento.value === null || dataAgendamento.value === dataMinimaAgendamento.value
      ? getHorarioLocalAtualComApenasHorasEMinutos()
      : null))

    const agendamento = ref({
      agenteId: null,
      tipoAgendamentoId: null,
      periodoDiaId: null,
      dataSolicitadaParaAgendamento: null,
      enderecoVisita: null,
      notificarLembrete: true,
      diasDeLembrete: 2,
      comentario: null,
    })
    const agenteExternoSelecionado = ref(null)
    const enderecoVisita = ref(new EnderecoModel())
    const statusSelecionadoId = ref(null)

    const isAgendamentoNovo = computed(() => props.agendamentoSelecionado === null)
    const desabilitarCampos = computed(() => !isAgendamentoNovo.value)

    async function getAgentesExternos() {
      if (isGetAgentesExternosLoading.value) return

      try {
        isGetAgentesExternosLoading.value = true
        agentesExternos.value = await EquipeService.getEquipesAgentesExternos()
      } finally {
        isGetAgentesExternosLoading.value = false
      }
    }

    async function getAgendamentosStatus() {
      if (isGetAgendamentosStatusLoading.value) return

      try {
        isGetAgendamentosStatusLoading.value = true
        agendamentosStatus.value = await TicketService.getAgendamentosStatus()
      } finally {
        isGetAgendamentosStatusLoading.value = false
      }
    }

    function resetData() {
      dataAgendamento.value = null
      horarioVisitaAgendamento.value = null

      usarEnderecoCadastro.value = false

      agendamento.value.agenteId = null
      agendamento.value.tipoAgendamentoId = null
      agendamento.value.periodoDiaId = null
      agendamento.value.enderecoVisita = null
      agendamento.value.dataSolicitadaParaAgendamento = null
      agendamento.value.notificarLembrete = true
      agendamento.value.diasDeLembrete = 2
      agendamento.value.comentario = null

      agenteExternoSelecionado.value = null
      enderecoVisita.value = new EnderecoModel()
      statusSelecionadoId.value = null

      resetFormValidation()
    }

    async function handleSubmitBtnClick() {
      if (isSaveAgendamentoLoading.value) return

      if (!validateForm()) {
        Vue.$toast(FORM_ERROR)
        return
      }

      try {
        isSaveAgendamentoLoading.value = true

        if (isAgendamentoNovo.value) {
          agendamento.value.enderecoVisita = JSON.parse(JSON.stringify(enderecoVisita.value))
          agendamento.value.dataSolicitadaParaAgendamento = concatenarIsoDateStringETimeStringEmIsoDateTimeString(dataAgendamento.value, horarioVisitaAgendamento.value)

          await TicketService.criarAgendamento(props.ticketId, agendamento.value)
        } else {
          await TicketService.atualizarAgendamentosStatus(props.ticketId, props.agendamentoSelecionado.id, {
            statusId: statusSelecionadoId.value,
          })
        }

        resetData()
        emit('refetch-data')
      } finally {
        isSaveAgendamentoLoading.value = false
      }
    }

    onMounted(() => {
      getAgentesExternos()
      getAgendamentosStatus()
    })

    watch(
      () => props.agendamentoSelecionado,
      v => {
        if (!v) {
          dataAgendamento.value = null
          horarioVisitaAgendamento.value = null

          agendamento.value.tipoAgendamentoId = null
          agendamento.value.comentario = null
          agenteExternoSelecionado.value = { id: null, nome: null }
          enderecoVisita.value = new EnderecoModel()

          return
        }

        const [dataAgendamento2, horarioVisitaAgendamento2] = v.dataSolicitadaParaAgendamento.split('T')

        dataAgendamento.value = dataAgendamento2
        horarioVisitaAgendamento.value = getTimeStringComApenasHorasEMinutos(horarioVisitaAgendamento2)

        agendamento.value.agenteId = v.agenteId
        agendamento.value.tipoAgendamentoId = v.tipoAgendamentoId
        agendamento.value.notificarLembrete = v.notificarLembrete
        agendamento.value.diasDeLembrete = v.diasDeLembrete

        agenteExternoSelecionado.value = {
          id: v.agenteId,
          nome: v.agenteNome,
          email: v.agenteEmail,
          telefone: v.agenteTelefone,
        }

        enderecoVisita.value = v.enderecoVisita
      },
      { immediate: true, deep: true },
    )

    function handleUsarEnderecoCadastroCheckboxChange(v) {
      if (v) {
        enderecoVisita.value = props.solicitantePrimeiroEnderecoCadastrado
      } else {
        enderecoVisita.value = new EnderecoModel()
      }
    }

    function handleSelectAgenteExterno(id) {
      agenteExternoSelecionado.value = agentesExternos.value[id]
    }

    function handleSelecionarDataAgendamento(date) {
      agenteExternoSelecionado.value = {
        id: date.agenteId,
        nome: date.agenteNome,
        email: date.agenteEmail,
        telefone: date.agenteTelefone,
      }

      dataAgendamento.value = date.dataAgendamento
      horarioVisitaAgendamento.value = date.horarioVisitaAgendamento

      agendamento.value.agenteId = date.agenteId
      agendamento.value.periodoDiaId = date.periodoDiaId
    }

    return {
      formRef,
      isSaveAgendamentoLoading,

      isDisponibilidadeDialogOpen,
      usarEnderecoCadastro,

      agentesExternos,
      agendamentosStatus,
      isGetAgentesExternosLoading,
      isGetAgendamentosStatusLoading,
      dataAgendamento,
      horarioVisitaAgendamento,
      statusSelecionadoId,
      dataMinimaAgendamento,
      horarioMinimoAgendamento,

      agendamento,
      agenteExternoSelecionado,
      enderecoVisita,

      isAgendamentoNovo,
      desabilitarCampos,

      handleUsarEnderecoCadastroCheckboxChange,
      handleSelectAgenteExterno,
      handleSelecionarDataAgendamento,
      handleSubmitBtnClick,

      validators: {
        required,
        select,
      },
      icons: {
        mdiCalendarCheck,
      },
    }
  },
}
</script>
